import { UserRolePipe } from '@shared/pipes/user-role.pipe';
import { DateFromNowPipe } from '@shared/pipes/date-from-now.pipe';
import { DefaultValuePipe } from '@shared/pipes/default-value.pipe';
import { PhonePrefixPipe } from '@shared/pipes/phone-prefix.pipe';
import { ContactNamePipe } from '@shared/pipes/contact-name.pipe';
import { SafeHtml2Pipe } from '@shared/pipes/safe-html-v2.pipe';

export const SHARED_PIPES = [
  UserRolePipe,
  DateFromNowPipe,
  DefaultValuePipe,
  PhonePrefixPipe,
  ContactNamePipe,
  SafeHtml2Pipe
];
